<template>
  <transition name="transitionheight">
  <div :class="'alert '+eventName" v-sticky sticky-offset="stickyOptions" v-if="visible">
    <img @click="closeAlert()" src="/static/img/close.svg" />
    <span v-html="text"></span>
  </div>
  </transition>
</template>

<script>
import Sticky from 'vue-sticky-directive'
import { get } from "lodash-es"

export default {
  components: { },
  directives: {Sticky},
  data () {
    return {
      visible:false,
      eventName:'',
      stickyOptions: {
        bottom: 200,
        top: 0,
        sticked: true
      },
      text:0,
      alertTextArray: [
        //0 generic error
        'Sorry, beim Aufruf der Seite ist leider ein Fehler aufgetreten. Lade die Seite einfach nochmal neu. Falls das Problem weiterhin auftritt, dann informiere uns bitte per E-Mail.',
        //1 secondary error
        'This alert is on purpose',
      ]
    }
  },
  methods: {
    alert: function(e){
      var vm=this;
      vm.text = get(e, 'text') ? e.text : vm.alertTextArray[get(e, 'alertId', 0)];
      vm.eventName = get(e, 'eventName') ? e.eventName : '';
      vm.openAlert();
      setTimeout(function(){
        vm.closeAlert();
      }, 5000);
    },
    openAlert:function() {
        this.visible = true;
    },
    closeAlert:function() {
        this.visible = false;
    },
  },
  mounted: function() {
    var vm=this;
    vm.$event.$on('alert', this.alert);
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/variables';

.alert {
  position: relative;
  z-index: 105;
  font-weight: 800;
  text-align: left;
  background-color: $danger;
  &.success{
    background-color: $success;
  }
  box-sizing: border-box;
  color:white;
  max-height: 10em;
  @include for-size(phone-only) {
    max-height: 15em;
  }
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  &>img{
    height:1em;
    position: absolute;
    right:1em;
    cursor:pointer;
    top:calc( 50% - 0.5em );
  }
  &>span{
    padding:1em;
    max-width: 90%;
  }
  &.transitionheight-enter-active, &.transitionheight-leave-active {
    transition: 0.5s max-height 0s ease;
  }
  &.transitionheight-enter, &.transitionheight-leave-to {
    max-height: 0em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/StickyAlert.vue